<template>
    <section class="gmp-section gmp-mb-l">

        <div class="two-column-tout two-column-tout--fullbleed">
            <div class="two-column-tout__side h-c-grid__col-l--order-2">
                <div class="two-column-tout__half-page two-column-tout__half-page--right">
                    <div class="two-column-tout__half-grid two-column-tout__half-grid--right">
                        <div class="two-column-tout__col two-column-tout__col--large">
                            <h3 class="h-c-headline h-c-headline--one">
                                降低进入门槛
                            </h3>
                            <p class="h-u-mb-std two-column-tout__description">
                                技术支持：加盟商无需建立复杂的IT基础设施，即可通过小程序使用先进的管理工具，降低了技术门槛和初期投入成本。
                                运营指导：小程序提供全面的运营指导和支持，使即使缺乏行业经验的加盟商也能迅速上手，减少了创业风险。
                            </p>
                            <a  @click="toEnterprisePage('/enterprise/franchiseStore/FS_Special','/enterprise/franchiseStore/FS_Special')"   class="h-c-link h-c-link--internal gmp-link">
                                查看所有特点</a>
                        </div>

                    </div>

                </div>
            </div>
            <div class="two-column-tout__side h-c-grid__col-l--order-1">
                <div class="two-column-tout__image two-column-tout__image--left">
                    <picture>
                        <img src="@/assets/img/twobleed.png" alt="" class="gmp-no-grab " >
                    </picture>

                </div>
            </div>

        </div>


    </section>
</template>

<script>
    export default {
        name: "FS_two_column_fullbleed",
        methods:{
            toEnterprisePage(data, url) {
                this.$router.push(data)
                this.$('body').removeClass('h-is-showing-drawer');
                var lis = this.$('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < lis.length; i++) {
                    var toWhere = this.$(lis[i]).attr('to-where');
                    console.log("toWhere===" + toWhere);
                    if (toWhere === url) {
                        this.$(lis[i]).addClass('h-is-active');
                    } else {
                        this.$(lis[i]).removeClass('h-is-active')
                    }
                }
            },
        }

    }
</script>

<style lang="less">


</style>